const partnerAppendixLink = (pid) =>
    `/api/user/partner_content/appendix/${pid}`

export default partnerAppendixLink